<script setup>
import Delimiter from '@sections/delimiter.vue'
import ProductCategory from '@sections/product/product-category.vue'
</script>
<template>
	<section class="container flex flex-col items-center gap-6 text-center">
		<span class="h9">products</span>
		<h1>Our products</h1>
	</section>
	<ProductCategory />
	<Delimiter />
</template>
